<template>
  <v-list-tile-content>
    <v-list-tile-title v-if="item.product_id === null || item.product_id === ''"
                       class="body-2 primary--text"
                       :class="{'playlist-content__tune-non-title' : !$store.getters.customerModulePlayListCommit}"
                       @click.stop="!$store.getters.customerModulePlayListCommit ? addTune() : false">曲未選択</v-list-tile-title>
    <v-list-tile-title v-else class="body-2">
      {{ item.name }}
      <span v-if="item.product_id === 1 && parseInt(item.isum_type) === 1">&nbsp;→&nbsp;記録(申請料)</span>
      <span v-else-if="item.product_id === 1 && parseInt(item.isum_type) === 2">&nbsp;→&nbsp;フリー</span>
    </v-list-tile-title>
    <router-link :to="'/home/artist/detail/' + item.artist_id">
      <v-list-tile-sub-title class="caption">{{ item.artist_name }}</v-list-tile-sub-title>
    </router-link>
    <v-list-tile-sub-title
      v-if="item.isum_code"
      class="caption">{{ item.isum_code }}/{{ item.isum_song_name }}/{{ item.isum_artist_name }}</v-list-tile-sub-title>
    <v-list-tile-sub-title
      v-if="parseInt(item.product_id) === 2"
      class="caption">{{item.other_song_name}}/{{item.other_artist_name}}</v-list-tile-sub-title>
  </v-list-tile-content>
</template>
<script>
export default {
  name: 'PlayListContent',
  props: {
    item: {
      default: {
        product_id: '',
        customer_playlist_product_id: '',
        isum_type: '',
        isum_code: '',
        isum_song_name: '',
        isum_artist_name: '',
        other_song_name: '',
        other_artist_name: '',
        artist_id: '',
        artist_name: '',
        scene_id: null
      }
    },
    playListType: {
      type: Number,
      default: 0
    },
    index: {
      default: 0
    }
  },
  methods: {
    addTune () {
      this.$store.dispatch('setSearchModal', [true, this.playListType, this.item.customer_playlist_product_id, this.index, this.item.scene_id])
    }
  }
}
</script>
<style lang="scss" scoped>
.playlist-content__tune-non-title {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/playListContent.vue